import {ServicesState, SitesState} from "../../../../../Store/Reducers/Dac/types";

export interface ServiceInt {
    abo_ht: number,
    pa_abo: number,
    fas_ht: number,
    pa_fas: number,
    mge_abo: number,
    tx_abo: number,
    mge_fas: number,
    quantity: number,
    tx_fas: number,
    aboUpgrade: number,
    fasUpgrade: number,
    discount_abo?: number,
    discount_fas?: number,
}

class TotalFunctions {

    static calcPrice(props: any) {
        this.dispatchTotalPerSite(props)
            .then(() => {
                this.dispatchTotal(props)
            })
    }

    // au changement du service dispatch les prix totaux de tout les sites
    static dispatchTotal(props: {sitesReducer: Array<SitesState>, discount_fas: number, discount_abo: number, receiveTotal: Function, editTotal: Function}) {
        const {sitesReducer, discount_fas, discount_abo, receiveTotal} = props;
        const tab = this.calcSumPerSites(sitesReducer, true);

        // Calculate aboUpgrade and fasUpgrade directly from all services
        const allServices = this.flattenAllServices(sitesReducer);
        const aboUpgrade = allServices.reduce((sum, service) => sum + (service.abo_ht || 0), 0);
        const fasUpgrade = allServices.reduce((sum, service) => sum + (service.fas_ht || 0), 0);
        
        // Override mge_abo and mge_fas with positive-only calculations
        const mge_abo = allServices.reduce((sum, service) => sum + Math.max(0, service.mge_abo || 0), 0);
        const mge_fas = allServices.reduce((sum, service) => sum + Math.max(0, service.mge_fas || 0), 0);

        receiveTotal({
            ...tab,
            aboUpgrade,
            fasUpgrade,
            mge_abo,
            mge_fas,
            discount_abo: discount_abo,
            discount_fas: discount_fas,
        })
    }

    // Helper method to flatten all services from all sites
    static flattenAllServices(sites: Array<SitesState>): Array<ServicesState> {
        const allServices: Array<ServicesState> = [];
        sites.forEach(site => {
            if (site.services && Array.isArray(site.services)) {
                allServices.push(...site.services);
            }
        });
        return allServices;
    }

    // au changement du service dispatch les prix totaux par site
    static async dispatchTotalPerSite(props: {sitesReducer: Array<SitesState>, editSites: Function}) {
        const {sitesReducer, editSites} = props;
        if(sitesReducer && sitesReducer.length > 0) {
            const copySites = [...sitesReducer];
            copySites.forEach((site: any, index: number) => {
                const tab = this.calcSumPerSites(site.services, false);
                for (let [key, value] of Object.entries(tab)) {
                    //@ts-ignore
                    site[key] = value;
                    editSites(key, value, index);
                }
            })
        }
    }

    static calcSumPerSites(tab: Array<SitesState | ServicesState>, isSite: boolean) {
        const values: ServiceInt = {
            abo_ht: 0,
            pa_abo: 0,
            fas_ht: 0,
            pa_fas: 0,
            mge_abo: 0,
            tx_abo: 0,
            mge_fas: 0,
            quantity: 0,
            tx_fas: 0,
            aboUpgrade: 0,
            fasUpgrade: 0,
        };
        if (tab && tab.length >= 0) {
            for (let key of Object.keys(values)) {
                let sum: number[] = [];
                
                // Special handling for aboUpgrade and fasUpgrade when calculating per-site
                if (!isSite && key === 'aboUpgrade') {
                    // Calculate from abo_ht including all values (positive and negative)
                    sum = Array.from(tab, service => (service.abo_ht || 0) * service.quantity);
                } else if (!isSite && key === 'fasUpgrade') {
                    // Calculate from fas_ht including all values (positive and negative)
                    sum = Array.from(tab, service => (service.fas_ht || 0) * service.quantity);
                } else if (!isSite || (key !== 'aboUpgrade' && key !== 'fasUpgrade')) {
                    // Regular calculation for other fields
                    // @ts-ignore
                    sum = Array.from(tab, service => isSite ? service[key] : service[key] * service.quantity);
                    
                    // For abo_ht and fas_ht, only include positive values
                    if (key === 'abo_ht' || key === 'fas_ht') {
                        sum = sum.filter(value => value > 0);
                    }
                }
                
                // @ts-ignore
                values[key] = sum.length > 0 ? sum.reduce((accumulator, currentValue) => accumulator + currentValue) : 0;
            }
        }
        return values;
    }
}

export default TotalFunctions;
